export default __webpack_public_path__ + "static/montserrat-v14-latin-regular-22d8566c41c8d731931b58ae64f72170.svg";